<div class="reviews-item" *ngIf="data">
    <div class="item-main">
        <div class="item-header">
            <div class="header-thumb" [ngStyle]="{'background-image': 'url(' + data.imgSrc + ')'}">
                <span *ngIf="!data.imgSrc">{{data.name[0].toUpperCase()}}</span>
            </div>
            <div class="header-text-wrapper">
                <span class="review-name">{{data.name}}</span>
                <span><img src="assets/img/stars.png" alt="rate"/></span>
            </div>
        </div>
        <div class="item-body">
            <h3>{{data.title}}</h3>
            <p>
                {{data.text}}
            </p>
        </div>
    </div>
    <div class="line"></div>
</div>
